import { render } from "./TestBehavioralStyle.vue?vue&type=template&id=d228650a&scoped=true"
import script from "./TestBehavioralStyle.vue?vue&type=script&lang=js"
export * from "./TestBehavioralStyle.vue?vue&type=script&lang=js"

import "./TestBehavioralStyle.vue?vue&type=style&index=0&id=d228650a&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\PLATEFORME-AUTO-PREFEREPLUS\\paprep-spa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d228650a"]])

export default __exports__